const VideoPlayer = ({ src, title }) => {

    return (
        <div>
           
        <iframe 
            width={560} 
            height={315}
            src= {src}
            title= {title ? title : 'Video'}
            frameborder="0" 
            allow="acelerometer; clipboard-write;web-share; gyroscope; fullscreen; autoplay; encrypted-media; picture-in-picture;"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen>
              
        </iframe>

    </div>
    )
    
}

export default VideoPlayer;